import {Link} from '@tkww/orion-web-ds-action';
import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';

const ActivatableLink = ({
  activeClassName,
  children,
  className,
  currentPath,
  href,
  ...props
}) => (
  <div className={style['navigation-links']}>
    <Link
      href={href}
      styleType="primary"
      size="lg"
      className={`${className} ${
        currentPath.match(href.split('/registry').pop()) ? activeClassName : ''
      }`}
      {...props}>
      <span>{children}</span>
    </Link>
  </div>
);

ActivatableLink.propTypes = {
  activeClassName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default ActivatableLink;
